import { render, staticRenderFns } from "./EditChargeGood.vue?vue&type=template&id=58fe2e1c&"
import script from "./EditChargeGood.vue?vue&type=script&lang=js&"
export * from "./EditChargeGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports